import React from 'react';

const MfpLoginPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/mfp-login',
			exact: true,
			component: React.lazy(() => import('./MfpLoginPage')),
		},
	],
};

export default MfpLoginPageConfig;
